import { Checkbox } from "@/components/ui/checkbox";
import { BrandName } from "@/lib/brand";

// Optional marketing consent, asked only on Step 1 (Contact). Shows the account's current choice; only the seller's own tick changes it.
export function PromoConsent({ contact, existing, onChange }) {
  const touched = contact?.promo_consent_method === "user";
  const checked = touched ? !!contact.promo_consent : !!existing?.subscribed;
  return (
    <div data-testid="promo-consent-block" className="pt-1">
      <label className="flex items-start gap-3 min-h-[44px] cursor-pointer">
        <Checkbox data-testid="promo-consent" checked={checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5 h-5 w-5" />
        <span className="text-sm text-stone-700">
          I'd like to receive horse sale announcements, newsletters and promotional messages from <BrandName /> by email or text message,
          based on my contact preferences. I can unsubscribe at any time. Application and contract updates are sent either way.
        </span>
      </label>
      {existing?.subscribed && !touched && (
        <p data-testid="promo-consent-current" className="ml-8 text-xs text-stone-500">
          You're currently subscribed{existing.consent_at ? ` (since ${new Date(existing.consent_at).toLocaleDateString()})` : ""}. Untick to unsubscribe.
        </p>
      )}
    </div>
  );
}
